import { InjectionToken } from '@angular/core';
import { HubApiModuleSettings } from './hub-api-module-settings';

export let HUB_API_SETTINGS_TOKEN = new InjectionToken<HubApiModuleSettings>('hubApiSettings');
